export default __webpack_public_path__ + "static/media/Ballroll_00288.83baf5f9.png";